// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__sgrvA","label":"SetPasswdForm_label__1V_9V"};